export const CHAT_CONFIG = {
  historyLimit: 5,
  scrollThreshold: 100,
  timeout: 15000,
  maxInputRows: 3,
}
